
import { defineComponent } from "vue";
import programs, { Program, ProgramList } from "@/program";

export default defineComponent({
  data(){
    return {
      hideSkip: false,
      detailsOpen: false,
      touchCount: 0,
    }
  },
  mounted(){
    const video = (this.$refs.video as HTMLVideoElement);
    video.addEventListener('timeupdate',()=>{
      if(video.currentTime > (this.program?.intro || 0)){
        this.hideSkip = true;
      } else {
        this.hideSkip = false;
      }
    })
  },
  methods: {
    play(){
      const videoContainer = (this.$refs.videoContainer as HTMLDivElement);
      const video = (this.$refs.video as HTMLVideoElement);
      videoContainer.classList.add('open');
      video.play();
    },
    pause(){
      const videoContainer = (this.$refs.videoContainer as HTMLDivElement);
      const video = (this.$refs.video as HTMLVideoElement);
      videoContainer.classList.remove('open');
      video.pause();
    },
    skipIntro(){
      const video = (this.$refs.video as HTMLVideoElement);
      video.currentTime = this.program?.intro || 0;
      video.play();
    },
    touch(e: TouchEvent){
      e.preventDefault();
      e.stopPropagation();
      if(this.touchCount == 0){
        this.detailsOpen = true;
        this.touchCount = 1;
      } else {
        window.open((e.target as HTMLAnchorElement).href, '_blank');
        this.detailsOpen = false;
        this.touchCount = 0;
      }
    },
    closeMore(){
      this.detailsOpen = false;
      this.touchCount = 0;
    },
  },
  computed: {
    style(): {[key:string]: string}{
      return {
        backgroundImage: `url('/img/film/${this.program?.slug}/room.jpg')`,
      }
    },
    program(): Program | undefined{
      return programs.find( program => program.slug === this.$route.params.id );
    },
  }
});
